export default __webpack_public_path__ + "static/mastercard-3fc5ca870a3891939229c70bebe25706.svg";